/**
 * API media — résolution `minio_key -> URL signée TTL=300s`.
 *
 * Le FE n'accède jamais directement à MinIO. Pour rendre `<img src=...>`,
 * il appelle `/api/media/url?key=<minio_key>` qui :
 *  1. Vérifie que la clé appartient à un work_media dont le work parent
 *     est possédé par l'utilisateur courant (404 sinon).
 *  2. Retourne un `presigned_get_object` MinIO valable 300s.
 *
 * Le hook `useMediaUrl` (cf. `hooks/useMediaUrl.ts`) cache l'URL avec
 * staleTime ~4 min — bien sous le TTL de 5 min, donc jamais d'image
 * cassée par expiration.
 */

import { apiClient } from './client'

export interface MediaUrlResponse {
  url: string
  minio_key: string
  ttl_seconds: number
}

export const mediaApi = {
  getUrl: async (minio_key: string): Promise<MediaUrlResponse> => {
    const { data } = await apiClient.get<MediaUrlResponse>('/media/url', {
      params: { key: minio_key },
    })
    return data
  },
}
